import { InverseHeader } from '@jouzen/ecom-components/layout';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

export interface AccoladesProps {
  alt: string;
  src: string;
  content: MessageKey;
}

const ACCOLADES_DATA: AccoladesProps[] = [
  {
    alt: 'Wired',
    src: 'product-accolades/wired@2x',
    content: 'accolades_wired',
  },
  {
    alt: 'Wirecutter',
    src: 'product-accolades/wirecutter',
    content: 'accolades_wirecutter',
  },
  {
    alt: 'The Verge',
    src: 'product-accolades/the-verge',
    content: 'accolades_theverge',
  },
  {
    alt: 'Vogue',
    src: 'product-accolades/vogue',
    content: 'accolades_vogue',
  },
];

const FitnessPress = () => {
  const t = useTranslations();

  return (
    <section>
      <InverseHeader enter className="bg-slate-700">
        <LayoutGrid>
          <GridItem colEnd={{ sm: 'full' }} colStart={{ sm: 1, md: 1, lg: 5 }}>
            <ArtDirectionImage
              width={1538}
              height={791}
              sizes="(min-width: 1024px) 80vw, 100vw"
              localizedAlt="fitness_press_press_img_atl"
              srcSet={[
                {
                  media: '(max-width: 1023px)',
                  src: 'fitness/fn-press-ring-closeup-fn-mobile',
                },
                {
                  media: '(min-width: 1024px)',
                  src: 'fitness/fn-press-ring-closeup-desktop',
                },
              ]}
            />
          </GridItem>
        </LayoutGrid>
        <div
          className={cx(
            'mx-6 flex max-w-(--breakpoint-xl) flex-col flex-wrap justify-center gap-8 py-10 md:flex-row md:gap-0 lg:py-20 xl:mx-auto',
          )}
        >
          {ACCOLADES_DATA.map((accolade) => (
            <div
              key={accolade.alt}
              className="p-4 text-white md:w-1/2 lg:w-1/4"
            >
              <Typography Element="h3" className="mb-5 flex h-10 items-end">
                <Image
                  src={accolade.src}
                  style={{ maxWidth: '75%' }}
                  className="mx-auto max-h-full w-auto"
                  alt={accolade.alt}
                  loading="lazy"
                  width="330"
                  height="50"
                  format="png"
                />
              </Typography>
              <Typography color="inherit" align="center">
                &lsquo;{t(accolade.content)}&rsquo;
              </Typography>
            </div>
          ))}
        </div>
      </InverseHeader>
    </section>
  );
};

export default FitnessPress;
